import Note from '@console/components/common/Note';
import { Link } from '@mui/material';

const IssueAmountRequestNotes: React.FC<Record<string, never>> = ({}) => (
  <>
    <Note>
      ※別途発行手数料がかかります。発行手数料は納品日ごとに計算されますので、ご注意ください。詳細は
      <Link
        underline="always"
        href="https://giftee.zendesk.com/hc/ja/articles/4404197192985"
        target="_blank"
        rel="noopener noreferrer"
      >
        こちら
      </Link>
      をご確認ください。
    </Note>
    <Note>
      ※既に希望納品日が過ぎている場合は、確定後、弊社営業担当か、右下のサポートよりご連絡ください。
    </Note>
    <Note>
      ※後払いのお手続きが完了していない場合、弊社にてご入金の確認ができ次第の納品となります。ご入金のタイミングや金融機関の営業日により、翌営業日以降の納品となる場合もございます。
    </Note>
  </>
);

export default IssueAmountRequestNotes;
